<ui-section class="mt-10" [title]="title">
	<ui-button
		(click)="add()"
		preset="MEDIUM_EMPHASIS"
		[intercomAttr]="
			title === soaDefaultsTitles.conveyancingFees
				? 'soc-conveyancing-fees-add-btn'
				: null
		"
		icon="plus"
		label="Add {{ title }}"
		title-action
	></ui-button>

	<div section-content cdkDropList (cdkDropListDropped)="_drop($event)">
		@if (
			showSolunoActivityCodeDropdown() ||
			showGhostPracticeCodeDropdown() ||
			showLeapFeeTaskCodesDropdown()
		) {
			<div class="flex ml-20 mt-2">
				<div class="flex-1 font-bold">Disbursement Details</div>
				<div class="w-32 font-bold">Price</div>
				<div class="min-w-[400px] ml-5 font-bold">
					{{ accountingCodeColumnLabel() }}
				</div>
			</div>
		}
		<div
			cdkDrag
			*ngFor="let statement of filteredOrderedStatements; trackBy: trackByFn"
			class="flex flex-col mt-5 static draggable-list draggable-item items-start"
		>
			<div class="flex flex-1 w-full">
				<div class="flex left-controls">
					<app-icon
						cdkDragHandle
						[icon]="ICON.SORT"
						class="text-grey-light hover:text-grey-darker cursor-pointer draggable-item mt-2"
					></app-icon>
					<app-button
						btn="tertiary"
						[holdable]="true"
						[icon]="ICON.DELETE"
						(onClick)="createDocOrSetHide(statement)"
						class="text-grey-light hover:text-grey-darker ml-2"
						*ngIf="statement?.deletable"
					></app-button>
				</div>
				<div class="flex flex-1 flex-col w-full mr-5">
					<app-input
						[ngModel]="statement.description"
						(debounce)="createDocOrSetDescription(statement, $event)"
					></app-input>
					<div class="flex flex-1 w-full">
						<div class="flex flex-1 w-full justify-between">
							<div class="flex gap-2">
								<div class="flex gap-2 items-center">
									<span class="text-sm" *ngIf="statement?.defaultDescription">{{
										statement.defaultDescription
									}}</span>
									<button
										class="text-green text-sm underline"
										*ngIf="statement?.containsDocumentText"
										(click)="editDocumentText(statement)"
										[attr.data-intercom-target]="statement.intercomId"
									>
										Edit text
									</button>
								</div>
								<div
									class="flex gap-1 items-center"
									*ngIf="
										statement?.globalDescription &&
										statement?.globalDescription !== statement?.description
									"
								>
									<app-icon
										[icon]="ICON.REFRESH"
										class="text-grey-light text-sm"
										*ngIf="statement?.globalDescription"
									></app-icon>
									<button
										class="text-grey-light text-sm underline"
										(click)="resetDescription(statement)"
										[matTooltip]="statement?.globalDescription"
									>
										Reset Description
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="flex flex-col">
					<div class="w-32 flex items-start">
						<app-input
							*ngIf="!statement?.calculated"
							type="cents"
							[ngModel]="statement.price"
							(debounce)="createDocOrSetPrice(statement, $event)"
							[startIcon]="ICON.DOLLAR"
							textAlign="right"
						></app-input>
						<span
							*ngIf="statement?.calculated"
							[attr.data-intercom-target]="statement.intercomId"
							>Calculated</span
						>
					</div>

					<div
						class="flex items-center gap-1"
						*ngIf="statement?.isBusinessDefaultPrice && !statement?.calculated"
					>
						<app-icon
							[icon]="ICON.REFRESH"
							class="text-grey-light text-sm"
						></app-icon>
						<button
							class="text-grey-light text-sm underline"
							(click)="resetPrice(statement)"
						>
							Reset Price
						</button>
					</div>
				</div>

				<div
					class="min-w-[400px] flex items-start ml-5"
					*ngIf="showSolunoActivityCodeDropdown()"
				>
					<app-searchable-dropdown
						[items]="solunoActivityCodesDropdownOptions"
						[ngModel]="statement.solunoActivityCode"
						placeholder="Select a code"
						[submitted]="true"
						(ngModelChange)="setSolunoActivityCode($event, statement)"
					></app-searchable-dropdown>
				</div>

				@if (showGhostPracticeCodeDropdown()) {
					<div class="min-w-[400px] flex items-start ml-5">
						<app-searchable-dropdown
							[items]="ghostPracticeCodesDropdownOptions"
							[ngModel]="statement.ghostPracticeCode"
							[backupValue]="
								getGhostPracticeCodeBackupValue(statement.ghostPracticeCode)
							"
							placeholder="Select a code"
							[submitted]="true"
							(ngModelChange)="setGhostPracticeCode($event, statement)"
						></app-searchable-dropdown>
					</div>
				}

				<div
					class="min-w-[400px] flex items-start ml-5"
					*ngIf="showLeapFeeTaskCodesDropdown()"
				>
					<app-searchable-dropdown
						[nullable]="false"
						[activityCodesLeap]="{
							codes: leapTaskCodes,
						}"
						[items]="
							statement.type === StatementOfAccountType.FEE
								? leapFeeTaskCodesDropdownOptions
								: leapCostRecoveryTaskCodesDropdownOptions
						"
						[ngModel]="
							statement.type === StatementOfAccountType.FEE
								? statement.leap?.feeTaskCode
								: statement.leap?.costRecoveryTaskCode
						"
						[backupValue]="
							getLeapCodeLabelDescription(
								statement.type === StatementOfAccountType.FEE
									? statement.leap?.feeTaskCode
									: statement.leap?.costRecoveryTaskCode
							)
						"
						placeholder="{{ placeholder }}"
						[submitted]="true"
						(ngModelChange)="
							statement.type === StatementOfAccountType.FEE
								? setLeapFeeTaskCode($event, statement)
								: setLeapCostRecoveryTaskCode($event, statement)
						"
					></app-searchable-dropdown>
				</div>
			</div>
		</div>

		<div *ngIf="deletedStatements?.length > 0">
			<div class="flex mt-5">
				<app-button
					btn="link"
					(click)="showDeleted = !showDeleted"
					[icon]="showDeleted ? ICON.HIDE : ICON.VIEW"
					size="small"
					>{{
						!showDeleted ? 'Show Deleted Defaults' : 'Hide Deleted Defaults'
					}}</app-button
				>
			</div>
			<div *ngIf="showDeleted">
				<div
					*ngFor="let statement of deletedStatements; trackBy: trackByFn"
					class="flex flex-col mt-5 items-start"
				>
					<div class="flex flex-1 w-full">
						<div class="flex left-controls items-center">
							<ui-button
								(click)="addBack(statement)"
								preset="EXTRA_LOW_EMPHASIS"
								icon="plus"
								matTooltip="Restore"
							></ui-button>
						</div>
						<div class="flex flex-1 flex-col w-full mr-5">
							<app-input
								[ngModel]="statement.description"
								[disabled]="true"
							></app-input>
						</div>
						<div class="w-32 flex items-start">
							<app-input
								*ngIf="!statement?.calculated"
								type="cents"
								[ngModel]="statement.price"
								[disabled]="true"
								[startIcon]="ICON.DOLLAR"
								textAlign="right"
							></app-input>
							<span
								*ngIf="statement?.calculated"
								[attr.data-intercom-target]="statement.intercomId"
								>Calculated</span
							>
						</div>

						<div
							class="min-w-[400px] flex items-start ml-5"
							*ngIf="showSolunoActivityCodeDropdown()"
						>
							<app-searchable-dropdown
								[nullable]="true"
								[activityCodes]="{
									codes: solunoActivityCodes,
									glAccounts: glAccounts,
								}"
								[items]="solunoActivityCodesDropdownOptions"
								[ngModel]="statement.solunoActivityCode"
								[backupValue]="
									getSolunoActivityCodeLabelDescription(
										statement?.solunoActivityCode
									)
								"
								placeholder="Select a code"
								[submitted]="true"
								[disabled]="true"
							></app-searchable-dropdown>
						</div>

						@if (showGhostPracticeCodeDropdown()) {
							<div class="min-w-[400px] flex items-start ml-5">
								<app-searchable-dropdown
									[nullable]="true"
									[items]="ghostPracticeCodesDropdownOptions"
									[ngModel]="statement.ghostPracticeCode"
									[backupValue]="
										getGhostPracticeCodeBackupValue(statement.ghostPracticeCode)
									"
									placeholder="Select a code"
									[submitted]="true"
									[disabled]="true"
								></app-searchable-dropdown>
							</div>
						}

						<div
							class="min-w-[400px] flex items-start ml-5"
							*ngIf="showLeapFeeTaskCodesDropdown()"
						>
							<app-searchable-dropdown
								[nullable]="false"
								[activityCodesLeap]="{
									codes: leapTaskCodes,
								}"
								[items]="
									statement.type === StatementOfAccountType.FEE
										? leapFeeTaskCodesDropdownOptions
										: leapCostRecoveryTaskCodesDropdownOptions
								"
								[ngModel]="
									statement.type === StatementOfAccountType.FEE
										? statement.leap?.feeTaskCode
										: statement.leap?.costRecoveryTaskCode
								"
								[backupValue]="
									getLeapCodeLabelDescription(
										statement.type === StatementOfAccountType.FEE
											? statement.leap?.feeTaskCode
											: statement.leap?.costRecoveryTaskCode
									)
								"
								placeholder="{{ placeholder }}"
								[disabled]="true"
							></app-searchable-dropdown>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ui-section>
